// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__PPMQX","loaderClass":"button_loaderClass__6QBvV","btnTitle":"button_btnTitle__HOtu0"};